import { isFunction } from 'lodash-es'

import { useToast } from '@composables'

export const useTryCatch = async (
  tryCallback,
  catchCallback = undefined,
  defaultMessage = 'An error has occurred. Kindly reach out to your administrator at support@limeiq.com for assistance.'
) => {
  if (!isFunction(tryCallback))
    throw new Error('The try callback must be a function.')

  const { showToast } = useToast()

  try {
    await tryCallback()
  } catch (e) {
    if (!!catchCallback) {
      if (!isFunction(catchCallback))
        throw new Error('The catch callback must be a function')

      catchCallback(e)
    } else {
      const { response } = e || {}

      if (!!response) {
        const { data } = response || {}
        const { data: error } = data || {}

        showToast(error.message || defaultMessage, 'error')
      } else {
        showToast(defaultMessage, 'error')
      }

      console.error(e)
    }
  }
}
